import styled from "styled-components";
import { ToastContainer } from "react-toastify";

export const StyledToast = styled(ToastContainer)`
  &&&.Toastify__toast-container {
  }
  .Toastify__toast {
  }
  .Toastify__toast-body {
  }
  .Toastify__close-button {
  }
  .Toastify__progress-bar {
  }
`;
